import { useAppSelector} from "../../../../app/store";
import React from "react";
import {Col} from "react-bootstrap";
import SlideEditor from "./SlideEditor";

const QuestionEditSlide = () => {
    const {content_id, slide_rows} = useAppSelector((state) => state.questionEditModal);

    return (
        <Col xs={12}>
            <SlideEditor slideRows={slide_rows} content_id={content_id || ''} />
        </Col>
    );
}

export default QuestionEditSlide;